import { useSelector } from '../../../../redux/store';
import useAuth from '../../../../hooks/useAuth';

// Practice admin or superuser: the same IsVoicePracticeAdmin rule as the
// Integrations card. The role is read from the practice-user list the header
// loads, with optional chaining rather than useIsSuperAdmin (which throws on a
// store without that slice): optional voice UI must never take a page down.
export default function useIsVoicePracticeAdmin() {
    const { user } = useAuth();
    const members = useSelector((state) => state.practiceUser?.practiceUser?.results);
    const me = (members || []).find((pu) => pu?.user && pu.user.id === user?.pk);
    return Boolean(user?.is_superuser || me?.user?.is_superuser || me?.role === 'ADMIN');
}
